'use strict';

exports.__esModule = true;
exports.transformProfileReviews = exports.transformInsurers = exports.transformTopLevelSpecialties = exports.transformSpecialties = exports.transformSpecialists = exports.transformPractice = undefined;

var _from = require('babel-runtime/core-js/array/from');

var _from2 = _interopRequireDefault(_from);

var _set = require('babel-runtime/core-js/set');

var _set2 = _interopRequireDefault(_set);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _capitalize2 = require('lodash/capitalize');

var _capitalize3 = _interopRequireDefault(_capitalize2);

var _doctifyUtils = require('doctify-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var moment = require('moment');

var getIconBaseUrl = function getIconBaseUrl() {
	return (0, _doctifyUtils.getResourcePath)('/img/specialty-icons/circle/');
};
/**
 * Returns the time in 12-hour format.
 * @param {string} time The time.
 * @return {string} The time in 12-hour format.
 */
var formatTime = function formatTime(time) {
	return moment.utc(time, 'HH:mm').format('h:mm A');
};

/**
 * Formats the opening hours.
 * @param {!Object} openingHours The opening hours.
 * @return {!Object} The formatted opening hours.
 */
var formatOpeningHours = function formatOpeningHours(openingHours) {
	return {
		start: openingHours && openingHours.start && formatTime(openingHours.start) || '',
		end: openingHours && openingHours.end && formatTime(openingHours.end) || ''
	};
};

/**
 * Formats the practice to match the props expected by the React element.
 * @param {!Object} practice The practice.
 * @return {!Object} The formatted practice.
 */
var transformPractice = exports.transformPractice = function transformPractice(practice) {

	var geolocation = JSON.parse(practice.address.geolocation);

	var address = {
		city: practice.address.city,
		country: practice.address.country,
		county: practice.address.county,
		position: {
			lat: geolocation && geolocation.coordinates.length && geolocation.coordinates[1],
			lng: geolocation && geolocation.coordinates.length && geolocation.coordinates[0]
		},
		google_place_id: practice.address.google_place_id,
		postcode: practice.address.postcode,
		street1: practice.address.street1,
		street2: practice.address.street2
	};

	var attributes = (0, _extends3.default)({}, practice.attributes, {
		weekday_opening_hours: practice && practice.attributes && practice.attributes.weekday_opening_hours && formatOpeningHours(practice.attributes.weekday_opening_hours) || '',
		weekend_opening_hours: practice && practice.attributes && practice.attributes.weekend_opening_hours && formatOpeningHours(practice.attributes.weekend_opening_hours) || ''
	});
	return (0, _assign2.default)({}, (0, _extends3.default)({}, practice, { address: address, attributes: attributes }));
};

/**
 * Helper function for the transformSpecialists function.
 * @param {!Array<Object>} specialist Specialist in question.
 * @param {!Array<Object>} specialtyListings All specialties available.
 *
 * @return {!String} Path to the icon corresponding to one of the specialists specialties.
 */
var specialtyIconUri = function specialtyIconUri(specialist, specialtyListings) {
	var specialties = specialist && specialist.specialist_specialties;
	var matchingSpecialty = void 0;

	var _loop = function _loop(i) {
		matchingSpecialty = specialties && specialtyListings && specialtyListings.find(function (specialty) {
			return specialties[i].id === specialty.id;
		});

		if (matchingSpecialty) {
			return 'break';
		}
	};

	for (var i = 0; i < specialties && specialties.length; i++) {
		var _ret = _loop(i);

		if (_ret === 'break') break;
	}
	return matchingSpecialty && (0, _doctifyUtils.getResourcePath)(matchingSpecialty.icon_uri) || (0, _doctifyUtils.getResourcePath)('/img/specialty-icons/avatar.png');
};

/**
 * Formats the specialists to match the props expended by the React component.
 * @param {!Array<Object>} specialists Specialists that belong to a practice.
 * @param {!Array<Object>} specialtyListings All specialties available.
 * @return {!Array<Object>} Specialists formatted to match the props of the
 *     React component.
 */
var transformSpecialists = exports.transformSpecialists = function transformSpecialists(specialists, specialtyListings) {
	// Return nothing if invalid specialist object exists. This is to deal with a potential DB error.
	var invalidSpecialistFound = false;
	specialists.forEach(function (specialist) {
		if ((typeof specialist === 'undefined' ? 'undefined' : (0, _typeof3.default)(specialist)) !== 'object' || specialist === null) {
			invalidSpecialistFound = true;
		}
	});

	return invalidSpecialistFound ? [] : specialists.map(function (specialist) {
		var topLevelSpecialty = specialist && specialist.specialist && specialist.specialist.specialties && specialist.specialist.specialties.find(function (specialty) {
			return specialty.parent_name === 'abstract_top_level_keyword';
		});

		return {
			uriId: specialist.specialist.uri_id,
			title: (0, _capitalize3.default)(specialist.specialist.title),
			firstname: (0, _capitalize3.default)(specialist.specialist.firstname),
			lastname: (0, _capitalize3.default)(specialist.specialist.lastname),
			profileImage: specialist && specialist.specialist && specialist.specialist.attributes && specialist.specialist.attributes.profile_featured_image && specialist.specialist.attributes.profile_featured_image + '_lg.jpg' || specialtyIconUri(specialist, specialtyListings),
			averageRating: specialist.specialist.average_review,
			hasBooking: specialist.specialist.has_booking,
			hasRequestAppointment: true,
			topLevelSpecialty: topLevelSpecialty && topLevelSpecialty.name,
			subspecialties: topLevelSpecialty && specialist && specialist.specialist && specialist.specialist.specialties && specialist.specialist.specialties.filter(function (specialty) {
				return specialty.parent_name === topLevelSpecialty.name;
			}).map(function (specialty) {
				return specialty.name;
			}),
			status: specialist && specialist.specialist && specialist.specialist.status
		};
	});
};

/**
* @TODO Remove with DS-294: https://doctify.atlassian.net/browse/DS-294
* Returns the filename extracted from the icon URI.
* @param {string} iconUri The practice icon URI.
* @return {string} The filename extracted from the icon URI.
*/
var getFilename = function getFilename(iconUri) {
	var parts = iconUri.split('/');
	return parts.length && parts[parts.length - 1];
};

/**
 * Retrieves the specialties from each specialist's top level specialty, and
 * returns an array with every unique specialty name and icon.
 * @param {!Array<Object>} specialties The listing of specialist keywords.
 * @param {!Array<Object>} specialists Specialists that belong to a practice.
 * @return {!Array<Object>} Unique practice especialties with name and icon.
 */
var transformSpecialties = exports.transformSpecialties = function transformSpecialties(specialties, specialists) {
	var practiceSpecialties = new _set2.default();

	specialists.forEach(function (specialist) {
		var topLevelSpecialty = specialist && specialist.specialist && specialist.specialist.specialties && specialist.specialist.specialties.find(function (specialty) {
			return specialty.parent_name === 'abstract_top_level_keyword';
		});

		var specialtyKeyword = topLevelSpecialty && specialties.find(function (specialty) {
			return specialty.id === topLevelSpecialty.id;
		});

		if (specialtyKeyword !== undefined) {
			practiceSpecialties.add(specialtyKeyword);
		}
	});

	return (0, _from2.default)(practiceSpecialties).map(function (specialty) {
		// @TODO Remove with DS-294: https://doctify.atlassian.net/browse/DS-294
		var filename = specialty && getFilename(specialty.icon_uri);

		return {
			name: specialty && specialty.name,
			img: filename && '' + getIconBaseUrl() + filename
		};
	});
};

/**
 * Returns the unique names of top level specialties for specialists in a
 * practice.
 * @param {!Array<Object>} specialists Specialists that belong to a practice.
 * @return {!Array<string>} Unique names of top level specialties.
 */
var transformTopLevelSpecialties = exports.transformTopLevelSpecialties = function transformTopLevelSpecialties(specialists) {
	var topLevelSpecialties = new _set2.default();

	specialists.forEach(function (specialist) {
		var topLevelSpecialty = specialist && specialist.specialist && specialist.specialist.specialties && specialist.specialist.specialties.find(function (specialty) {
			return specialty.parent_name === 'abstract_top_level_keyword';
		});

		if (topLevelSpecialty && topLevelSpecialty.name) {
			topLevelSpecialties.add(topLevelSpecialty.name);
		}
	});

	return (0, _from2.default)(topLevelSpecialties);
};

/**
 * Formats the practice insurers to match the props required by the React
 * component.
 * @param {!Array<Object>} practiceInsurers The practice insurers.
 * @param {!Array<Object>} insurers Listing of insurers.
 * @return {!Array<Object>} The practice insurers formatted to match the props
 *     of the React component.
 */
var transformInsurers = exports.transformInsurers = function transformInsurers(practiceInsurers, insurers) {
	return practiceInsurers ? practiceInsurers.map(function (practiceInsurer) {
		var insurerData = insurers.find(function (insurer) {
			return insurer.id === practiceInsurer.id;
		});

		return {
			url: insurerData.icon_uri && (0, _doctifyUtils.getResourcePath)(insurerData.icon_uri),
			website: insurerData.website
		};
	}) : [];
};

var transformProfileReviews = exports.transformProfileReviews = function transformProfileReviews(reviews) {
	return reviews.map(function (review) {
		return {
			reviewDate: moment.utc(review.timestamp_created).format('DD-MM-YYYY'),
			review: review.review.body,
			numberOfStars: review.aggregate_score,
			likes: review.review.likes,
			id: review.id,
			status: review.status,
			is_verified: review.is_verified,
			comment: review.review && review.review.comments && review.review.comments.appointment_comments && review.review.comments.appointment_comments[0]
		};
	});
};


// WEBPACK FOOTER //
// ./components/practice-page/lib/transformers/practice-page.js